import { render, staticRenderFns } from "./ChangeRequestFileUpload.vue?vue&type=template&id=08844482&scoped=true"
import script from "./ChangeRequestFileUpload.vue?vue&type=script&lang=ts"
export * from "./ChangeRequestFileUpload.vue?vue&type=script&lang=ts"
import style0 from "./ChangeRequestFileUpload.vue?vue&type=style&index=0&id=08844482&prod&scoped=true&lang=css"
import style1 from "./ChangeRequestFileUpload.vue?vue&type=style&index=1&id=08844482&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08844482",
  null
  
)

export default component.exports